import { NepaliDate, ADtoBS, BStoAD, NEPALI_DATE_MAP } from 'nepali-date-library';

// Helper functions for date calculations
function getStartDateForYear(year) {
    // This is a simplified implementation - you might need to adjust based on your specific needs
    const yearData = NEPALI_DATE_MAP.find(item => item.year === year);
    if (!yearData) return null;
    
    // Calculate approximate start date (April 13/14 of previous year)
    const startYear = year - 57; // Approximate conversion
    return `04/13/${startYear}`;
}

function getEndDateForYear(year) {
    // This is a simplified implementation - you might need to adjust based on your specific needs
    const yearData = NEPALI_DATE_MAP.find(item => item.year === year);
    if (!yearData) return null;
    
    // Calculate approximate end date (April 12/13 of current year)
    const endYear = year - 56; // Approximate conversion
    return `04/12/${endYear}`;
}

export default {
    // Keep the original nepaliDate array for backward compatibility
    nepaliDate: NEPALI_DATE_MAP.map(item => ({
        Year: item.year,
        StartDate: getStartDateForYear(item.year),
        EndDate: getEndDateForYear(item.year),
        Days: item.days
    })),

    getYears() {
        // Return years in descending order (newest first) as per original implementation
        return NEPALI_DATE_MAP.map(item => item.year).sort((a, b) => b - a);
    },

    getDaysInMonth(year, month) {
        const yearData = NEPALI_DATE_MAP.find(item => item.year === year);
        if (!yearData) return null;
        return yearData.days[month - 1]; // month is 1-indexed
    },

    pad(n) {
        return parseInt(n) < 10 ? ("0" + n) : ("" + n);
    },

    convertToEnglishDate(nepaliDate) {
        if (nepaliDate == null || nepaliDate == "") {
            return null;
        }
        
        try {
            // Parse the Nepali date string (format: YYYY-MM-DD)
            const parsedDate = this.parseNepaliDate(nepaliDate);
            if (!parsedDate.year || !parsedDate.month || !parsedDate.day) {
                return null;
            }

            // Create NepaliDate object and get English date
            const nepaliDateObj = new NepaliDate(parsedDate.year, parsedDate.month - 1, parsedDate.day);
            const englishDate = nepaliDateObj.getEnglishDate();
            
            return this.stringifyEnglishDate(
                englishDate.getFullYear(), 
                englishDate.getMonth() + 1, 
                englishDate.getDate()
            );
        } catch (error) {
            console.error('Error converting Nepali date to English:', error);
            return null;
        }
    },

    convertToNepaliDate(engDateStr) {
        if (engDateStr == null || engDateStr == "") {
            return null;
        }

        try {
            let engDate;
            if (engDateStr instanceof Date) {
                engDate = engDateStr;
            } else {
                // Handle different date formats
                if (typeof engDateStr === 'string') {
                    // If it's already in YYYY-MM-DD format, use it directly
                    if (/^\d{4}-\d{2}-\d{2}$/.test(engDateStr)) {
                        engDate = new Date(engDateStr);
                    } else {
                        // Add time component for other formats
                        engDate = new Date(engDateStr + " 00:00:00");
                    }
                } else {
                    engDate = new Date(engDateStr);
                }
            }

            // Create NepaliDate from English date
            const nepaliDateObj = new NepaliDate(engDate);
            
            return this.stringifyNepaliDate(
                nepaliDateObj.getYear(),
                nepaliDateObj.getMonth() + 1, // Convert to 1-indexed month
                nepaliDateObj.getDate()
            );
        } catch (error) {
            console.error('Error converting English date to Nepali:', error);
            return null;
        }
    },

    parseNepaliDate(date) {
        let response = {
            year: null,
            month: null,
            day: null
        };
        
        if (date != null) {
            let splitted = date.split(/\D/);
            response.year = parseInt(splitted[0]);
            response.month = splitted[1];
            response.day = splitted[2];
        }
        
        return response;
    },

    parseEnglishDate(date) {
        return this.parseNepaliDate(date);
    },

    stringifyNepaliDate(year, month, day) {
        let nepaliDateSeparater = "-";
        if (year != null && month != null && day != null) {
            return year + nepaliDateSeparater + this.pad(month) + nepaliDateSeparater + this.pad(day);
        } else {
            return null;
        }
    },

    stringifyEnglishDate(year, month, day) {
        return this.stringifyNepaliDate(year, month, day);
    },

    getTodayNepaliDate() {
        return this.convertToNepaliDate(new Date());
    },


    // Additional utility methods that might be useful
    isValidNepaliDate(year, month, day) {
        try {
            return NepaliDate.isValid(year, month - 1, day);
        } catch (error) {
            return false;
        }
    },

    getDaysInYear(year) {
        const yearData = NEPALI_DATE_MAP.find(item => item.year === year);
        return yearData ? yearData.totalDays : null;
    },

    isLeapYear(year) {
        const yearData = NEPALI_DATE_MAP.find(item => item.year === year);
        return yearData ? yearData.totalDays === 366 : false;
    }
};